import React, { useLayoutEffect } from 'react';
import { StackModal } from 'Components/StackModal';
import { DISONA_MODAL_IDS } from 'common/constants/modal.constants';
import { CustomFreshChatBtn } from 'common/ui/themes/disona/atoms/CustomFreshChatBtn';
import { BurgerBtn } from 'common/ui/themes/disona/atoms/BurgerBtn';
import { FlexBox } from 'Components/FlexBox';
import { inject, observer } from 'mobx-react';
import {
  PRIMARY_PAGES,
  SECONDARY_PAGES,
} from 'Components/AppLayout/disona/menu.constants';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_TYPES_SWITCH } from 'common/constants/trading.constants';
import routes from 'common/constants/routing.constants';
import { useWindowSize } from 'common/utils/style.util';
import { BREAKPOINTS } from 'themes/media';
import history from 'customHistory';
import { Select } from 'pages/Trading/themes/disona/mobile/Components/TradingAccountScreen/Select/index.js';
import * as S from './styled';

const MenuItem = ({ item, children, ...restProps }) => {
  const { path, Icon } = item;
  return (
    <S.Item
      to={path}
      isActive={path === window.location.pathname}
      {...restProps}
    >
      <S.ItemIcon>
        <Icon />
      </S.ItemIcon>
      <S.ItemText>{children}</S.ItemText>
    </S.Item>
  );
};

const ModalContent = inject(
  'ModalStore',
  'AppStore',
  'ProfileStore'
)(
  observer(({ ModalStore, ProfileStore, AppStore }) => {
    const { t } = useTranslation();
    const window = useWindowSize();

    useLayoutEffect(() => {
      if (window.width > BREAKPOINTS.desktop) {
        ModalStore.back();
      }
    }, [window.width]);

    const changeValue = ({ item, setOpen }) => {
      if (item.value === 'Real' && ProfileStore.needInfoAndHaveData) {
        history.push(routes.profile.path);
      } else {
        AppStore.changeAccountType(item.value);
        setOpen(false);
      }
    };

    return (
      <>
        <S.Overlay
          onClick={() => {
            ModalStore.back();
          }}
        />
        <S.Container height={window.height}>
          <S.Shadow />
          <S.Header>
            <S.Title>Disona</S.Title>
            <FlexBox>
              <CustomFreshChatBtn
                style={{
                  marginRight: '10px',
                }}
              />
              <BurgerBtn
                isOpen
                onClick={() => {
                  ModalStore.back();
                }}
              />
            </FlexBox>
          </S.Header>
          <S.Main>
            <S.Grid>
              {PRIMARY_PAGES.map((item) => (
                <MenuItem
                  onClick={() => {
                    ModalStore.back();
                  }}
                  item={item}
                  key={item.name}
                >
                  {t(item.name)}
                </MenuItem>
              ))}
            </S.Grid>
            <S.Separator />
            <S.Grid>
              {SECONDARY_PAGES.map((item) => (
                <MenuItem
                  disabled={item.disabled}
                  onClick={() => {
                    if (!item.disabled) ModalStore.back();
                  }}
                  item={item}
                  key={item.name}
                >
                  {t(item.name)}
                </MenuItem>
              ))}
            </S.Grid>
          </S.Main>
          <S.Footer>
            <FlexBox>
              <S.SelectWrapper>
                <S.SelectTitle>Accounts:</S.SelectTitle>

                <Select
                  options={ACCOUNT_TYPES_SWITCH}
                  value={ACCOUNT_TYPES_SWITCH.find(
                    (item) => item.value === AppStore.getAccountType
                  )}
                  setValue={(item) => AppStore.changeAccountType(item.value)}
                  shadow
                  onChange={changeValue}
                />
              </S.SelectWrapper>
            </FlexBox>
            <div>
              <S.LogoutBtn onClick={AppStore.logout}>
                {t('common.menu.logout')}
              </S.LogoutBtn>
            </div>
          </S.Footer>
        </S.Container>
      </>
    );
  })
);

export const MenuModal = () => (
  <StackModal modalID={DISONA_MODAL_IDS.APP_MENU}>
    <ModalContent />
  </StackModal>
);
